import { render } from "./CardWithHeaderAndFooterComponent.vue?vue&type=template&id=52718a60"
import script from "./CardWithHeaderAndFooterComponent.vue?vue&type=script&lang=js"
export * from "./CardWithHeaderAndFooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__